import React from "react";
import { arrayOf, object, string } from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import Event from "./event";

const Events = ({ events, title }) => {
  return (
    <section id="events" className="page-section bg-color-2 text-center">
      <Container>
        <h2>{title}</h2>
        <hr className="small" />
        {events.length > 0 ? (
          <Row>
            {events.map((e, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Col sm key={i}>
                <Event
                  title={e.title}
                  venue={e.venue}
                  street={e.street}
                  town={e.town}
                  postcode={e.postcode}
                  startDateTime={e.startDateTime}
                  endDateTime={e.endDateTime}
                  info={e.info}
                />
              </Col>
            ))}
          </Row>
        ) : (
          <p className="lead">
            We have no events planned at the moment. Please check back later.
          </p>
        )}
      </Container>
    </section>
  );
};

Events.propTypes = {
  events: arrayOf(object).isRequired,
  title: string.isRequired
};

export default Events;
